import { api } from "@/api";
import { QueryConfig, QueryResult } from "@/shared/types/base";
import { Cotizacion } from "@/shared/types/cotizacion";
import { sleep } from "@/shared/utils";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";
import { sortMonedas } from "../shared/utils";

export async function getCotizacion(): Promise<Cotizacion> {
    await sleep(1000);
    const response = await api.get("monetizacion/cotizacion")
    const cotizacion = response.data as Cotizacion;
    cotizacion.cotizacionItems = sortMonedas(cotizacion.cotizacionItems)
    return cotizacion;
}

export function useGetCotizacionQuery(queryConfig: QueryConfig<Cotizacion> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getCotizacion(),
        queryKey: ["monetizacion", "cotizacion"],
    })
}

export interface GetCotizacionQueryProps {
    queryConfig?: QueryConfig<Cotizacion>,
    children?: (queryResult: QueryResult<Cotizacion>) => ReactNode
}

export function GetCotizacionQuery({
    children,
    queryConfig
}: GetCotizacionQueryProps) {
    const queryResult = useGetCotizacionQuery(queryConfig);
    return children && children(queryResult);
}